import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  FileLabel,
} from '@savgroup-front-common/types';

import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}carriers/files/${COMMON_QUERY_PARAMS.FILE_ID}/labels`;

interface GetCarrierLabelsInfosQueryArgs {
  fileId: string;
}

export const getCarrierLabelsInfosRequest = ({
  fileId,
}: GetCarrierLabelsInfosQueryArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getCarrierLabelsInfosQuery = async (
  payload: GetCarrierLabelsInfosQueryArgs,
): Promise<BackResponse<FileLabel[] | undefined> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileLabel[] | undefined>>(
      getCarrierLabelsInfosRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getCarrierLabelsInfosQuery;
